import _ from 'lodash';
import React, { Component } from 'react';
import moment from 'moment-timezone';

import {
  Alert,
  Button,
  Card,
  Col,
  Form,
  Icon,
  Modal,
  Row,
  Tabs,
} from 'grab-ui';
import { Divider, Flex, Tag } from '@duxton-web/ui';
import { Link } from 'react-router';
import { connect } from 'react-redux';

import DataBox from 'omega-rtc/components/custom/DataBox';
import { hasJustSuccess, isRequestsPending } from 'utils/request-state-utils';
import ProgressiveContainer from 'components/container/ProgressiveContainer';
import DuplicateIcon from 'img/ucd_duplicate.svg';
import EditIcon from 'img/ucd_edit.svg';
import DeactivateIcon from 'img/ucd_deactivate.svg';
import Toastr from 'utils/toastr-util';
import {
  copyToClipboard,
  getRequestStateKey,
  getTimezoneNameFromAbbrv,
} from 'omega-rtc/utils/ucd-utils';
import JourneyBuilder from 'omega-rtc/components/journey-builder/Layout';
import CampaignApprovalRequestForm from './CampaignApprovalRequestForm';

import {
  GET_TRIDENT_CAMPAIGN,
  GET_UCD_CAMPAIGN,
  GET_UCD_PROJECT,
  getUCDCampaign,
  getUCDProject,
  getTridentCampaign,
  UPDATE_UCD_CAMPAIGN_STATUS,
  updateUCDCampaignStatus,
  deactivateTridentCampaign,
  DEACTIVATE_TRIDENT_CAMPAIGN,
} from 'omega-rtc/actions/ucd';
import UCDStatusLabel from 'omega-rtc/components/form/ucd/common/UCDStatusLabel';
import {
  BUDGET_SOURCE_DISPLAY_NAMES,
  CHANNEL_GROUPS,
  INTERNAL_STATUS,
  QUERY_PARAM_KEYS,
  UCD_ACTION_TYPES,
  UCD_RESOURCE_NAMES,
  UCD_ROUTES_LINK,
  VERTICALS_DISPLAY_NAMES,
  TRIDENT_CAMPAIGN_TEMPLATE,
  OBJECTIVES,
} from 'omega-rtc/constants/ucd';
import { tridentCampaigns } from 'omega-rtc/links';
import SingleSelectMenu from 'omega-rtc/components/form/ucd/common/SingleSelectMenu';
import UCDObjectiveLabel from 'omega-rtc/components/form/ucd/common/UCDObjectiveLabel';
import AddCampaignTypeForm from 'omega-rtc/components/form/ucd/AddCampaignTypeForm';
import ShowIfAuthorized from 'omega-rtc/components/form/ucd/common/ShowIfAuthorized';

import './UCDHomePage.scss';
import './CampaignDetail.scss';
import scribe from '@grab-x/scribe-web-sdk';
import ScribeEventName from 'omega-rtc/constants/scribe';
import openLinkIcon from 'img/open_link.svg';
import addCampaignIcon from 'img/ucd_add_campaign_2.svg';
import pendingApprovalIcon from 'img/ucd_campaign_pending_approval.svg';
import campaignReviewIcon from 'img/ucd_campaign_review.svg';
import {
  getSegmentUrl,
  getHedwigTemplateUrl,
} from 'views/trident-campaigns/review/campaign-analysis';
import {
  doCampaignApprovalFlowAction,
  getFeatureFlagConfig,
  campaignApprovalFlowActions,
  CAMPAIGN_APPROVAL_FLOW,
} from 'omega-rtc/actions/newTridentExtra';
import { processCampaignData } from 'omega-rtc/utils/scribe';
import {
  isTaiwanCampaignCreationAllowed,
  TAIWAN_CAMPAIGN_CREATION_RESTRICTED_MESSAGE,
} from 'omega-rtc/utils/taiwan-campaign-operation';
import PerformancePage from 'omega-rtc/views/ucd/PerformancePage';
import { actionTypeToTemplateType } from 'data/trident-campaigns';
import { hasTridentPermission } from 'omega-rtc/utils/user-utils';
import VersionHistoryList from 'omega-rtc/views/trident-campaigns/common/VersionHistoryList';

const CAMPAIGN_DETAIL_TABS = {
  overview: 'Overview',
  performance: 'Performance',
};

interface EditRecord {
  time: string;
  editor: string;
  change: {
    type: string;
  };
}

interface Props {
  projectID: string;
  campaignID: string;
  router: any;
  activateCampaign: (projectID: string, campaignID: string, user: string) => void;
  deactivateCampaign: (projectID: string, campaignID: string, user: string) => void;
  user: any;
  previousPageIsListing: boolean;
  userPermissions: any;
  campaignView: any;
  tridentCampaignView: any;
  projectView: any;
  countries: any;
  approvalRequest: any;
  updateCampaignStatusRequest: any;
  deactivateTridentCampaignRequest: any;
  campaignApprovalFlowRequest: any;
  getCampaignRequest: any;
  getProjectRequest: any;
  getTridentCampaignRequest: any;
  getCampaign: (projectID: string, campaignID: string) => void;
  getProject: (projectID: string) => void;
  withdrawTridentCampaign: (countryID: number, campaignID: string, data: any) => void;
  featureFlagConfig: Object;
  getFeatureFlagConfig: () => void;
}

interface State {
  statusRequestType: string;
  showApprovalRequestModal: boolean;
  projectDetailCurrentTab?: string;
  showVersionHistoryModal: boolean;
}

class CampaignDetailPage extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      statusRequestType: '', // to record whether user just triggers activate or deactivate
      showApprovalRequestModal: false,
      showVersionHistoryModal: false,
    };
    const { projectID, campaignID, getCampaign, getProject } = this.props;
    getCampaign(projectID, campaignID);
    getProject(projectID);
  }

  componentDidMount() {
    this.props.getFeatureFlagConfig();
    const toastrMessage = sessionStorage.getItem('toastrMessage');
    if (toastrMessage) {
      Toastr.success(toastrMessage);
      sessionStorage.removeItem('toastrMessage');
    }
  }

  componentWillReceiveProps(nextProps: Props) {
    const { statusRequestType } = this.state;
    const { getTridentCampaign } = this.props;
    const campaignView = _.get(this.props, 'campaignView', { campaign: {} });
    if (
      hasJustSuccess(
        this.props.updateCampaignStatusRequest,
        nextProps.updateCampaignStatusRequest,
      )
    ) {
      Toastr.success(
        `${_.get(campaignView, 'campaign.name', 'Campaign')} has been ${
          statusRequestType === INTERNAL_STATUS.active
            ? 'activated'
            : 'deactivated'
        } successfully.`,
      );
    }

    if (
      hasJustSuccess(
        this.props.deactivateTridentCampaignRequest,
        nextProps.deactivateTridentCampaignRequest,
      )
    ) {
      Toastr.success('Trident campaign has been deactivated successfully');
      this.setState({
        statusRequestType: INTERNAL_STATUS.deactivated,
      });
    }

    if (
      hasJustSuccess(
        this.props.getCampaignRequest,
        nextProps.getCampaignRequest,
      )
    ) {
      const { campaignView, projectID, campaignID } = nextProps;
      const templateType = _.get(campaignView, 'campaign.templateType');
      if (templateType === TRIDENT_CAMPAIGN_TEMPLATE.multistepJourney) {
        getTridentCampaign(projectID, campaignID);
      }
    }

    const { projectID, campaignID } = this.props;
    if (
      hasJustSuccess(
        this.props.campaignApprovalFlowRequest,
        nextProps.campaignApprovalFlowRequest,
      ) &&
      _.get(nextProps, 'approvalRequest.actionType') === 'withdraw'
    ) {
      sessionStorage.setItem(
        'toastrMessage',
        'Campaign has been successfully withdrawn',
      );

      const templateType = _.get(campaignView, 'campaign.templateType');
      if (templateType) {
        nextProps.router.push(
          UCD_ROUTES_LINK.TRIDENT_CAMPAIGN_EDIT(projectID, campaignID),
        );
      } else {
        window.location.reload();
      }
    }
  }

  getTabLabel = (tab: string) => {
    const { projectDetailCurrentTab } = this.state;
    return projectDetailCurrentTab === tab ? <b>{tab}</b> : tab;
  };

  handleClickAddTridentCampaign = (e: React.MouseEvent) => {
    e.preventDefault();
    if (
      !isTaiwanCampaignCreationAllowed(
        _.get(this.props, 'campaignView.countryID'),
        _.get(this.props, 'user.email'),
      )
    ) {
      Toastr.error(TAIWAN_CAMPAIGN_CREATION_RESTRICTED_MESSAGE);
      return;
    }

    const redirectURL = window.location.href.replace('view', 'trident/create');
    window.location.href = redirectURL;
  };

  handleRequestApproval = (e: React.MouseEvent) => {
    e.preventDefault();
    this.setState({
      showApprovalRequestModal: true,
    });
  };

  handleWithdraw = () => {
    const { countryID, campaign } = _.get(this.props, 'campaignView', {});
    this.props.withdrawTridentCampaign(countryID, campaign.mamCampaignID, {
      adminEmail: this.props.user.email,
      notifyees: [],
    });

    scribe.sendEvent(
      ScribeEventName.CAMPAIGN_WITHDRAWN,
      processCampaignData({
        ..._.get(this.props, 'campaignView', {}),
        user: this.props.user,
      }),
    );
  };

  closeRequestApprovalModal = (e: React.MouseEvent) => {
    e.preventDefault();
    this.setState({
      showApprovalRequestModal: false,
    });
  };

  handleShowVersionHistory = () => {
    this.setState({
      showVersionHistoryModal: true,
    });
  };

  closeVersionHistoryModal = () => {
    this.setState({
      showVersionHistoryModal: false,
    });
  };

  handleBackButton = (previousPageIsListing: boolean, projectID: string) => {
    if (previousPageIsListing) {
      this.props.router.goBack();
    } else {
      this.props.router.push(UCD_ROUTES_LINK.PROJECT_VIEW(projectID));
    }
  };

  render() {
    const {
      projectID,
      campaignID,
      router,
      activateCampaign,
      deactivateCampaign,
      user,
      previousPageIsListing,
      userPermissions,
      featureFlagConfig,
    } = this.props;

    const campaignView = _.get(this.props, 'campaignView', { campaign: {} });
    let { tridentCampaignView = { campaign: {} } } = this.props;

    if (tridentCampaignView.campaignID !== campaignID) {
      tridentCampaignView = { campaign: {} };
    }

    const editRecords = _.get(campaignView, 'edits', []).map((record: EditRecord) => ({
      time: record.time,
      editor: record.editor,
      changeType: record.change.type,
    }));

    const projectView = _.get(this.props, 'projectView', { project: {} });
    const isMetricsAvailable = _.get(campaignView, 'isMetricsAvailable', false);
    const isLoadingPage =
      isRequestsPending(
        this.props.getCampaignRequest,
        this.props.getProjectRequest,
      ) || !user;

    const {
      name,
      channelGroup,
      channels,
      start,
      startTime,
      timezone,
      link,
      end,
      endTime,
      verticals,
      budgetSource,
      code,
      otherDetails,
    } = campaignView.campaign;

    const { createdBy, audience, objective, countryID } = campaignView;
    const { statusRequestType } = this.state;
    const status = statusRequestType || campaignView.status;
    const isMetricsTabDisabled = objective === OBJECTIVES.communications;

    const countries = this.props.countries;
    const countryTimezones = _.get(
      _.find(countries, { countryID }, {}),
      'timezones',
      [],
    );
    const timezoneName = timezone
      ? getTimezoneNameFromAbbrv(timezone, countryTimezones)
      : 'UTC';

    const campaignStartTime = startTime
      ? moment(startTime).tz(timezoneName).format('DD/MM/YYYY HH:mm Z')
      : moment(start).format('DD/MM/YYYY');
    const campaignEndTime = endTime
      ? moment(endTime).tz(timezoneName).format('DD/MM/YYYY HH:mm Z')
      : moment(end).format('DD/MM/YYYY');

    let channelGroupLabelCreate = null;
    const isHedwigOrTrident =
      channelGroup === CHANNEL_GROUPS.hedwig ||
      channelGroup === CHANNEL_GROUPS.trident;
    if (channelGroup === CHANNEL_GROUPS.hedwig) {
      channelGroupLabelCreate = {
        href: window.Grab.config.HEDWIG_DASH_URI,
        label: 'Open Hedwig',
      };
    } else if (channelGroup === CHANNEL_GROUPS.trident) {
      channelGroupLabelCreate = {
        onClick: () => router.push(tridentCampaigns.webPath),
        label: 'Open Trident',
      };
    }

    const getOtherDetailItems = (title: string, propName: string) => {
      const otherDetailsItems = _.find(
        otherDetails,
        (item) => item.title === title,
      );
      if (_.isEmpty(otherDetailsItems) || _.isEmpty(otherDetailsItems.items)) { return []; }

      const uniqueItems = otherDetailsItems.items.reduce((acc: any[], item: any) => {
        if (
          !acc.some((uniqueItem) => uniqueItem[propName] === item[propName])
        ) {
          acc.push(item);
        }
        return acc;
      }, []);

      return uniqueItems;
    };

    const getLinker = (text: string, url: string) => {
      return (
        <div className="linker">
          <Link to={url} target="_blank">
            <span>{text} </span>
            <img src={openLinkIcon} height={'9px'} alt={''} />
          </Link>
        </div>
      );
    };

    const userType = _.get(campaignView, 'audience', '').toUpperCase();

    const conditionDetails = getOtherDetailItems('Condition', 'label');
    const actionDetails = getOtherDetailItems('Action', 'label');
    const segmentDetails = getOtherDetailItems('Segment', 'ID');
    const hedwigDetails = getOtherDetailItems('Hedwig', 'ID');

    const isWithdrawRequestPending = isRequestsPending(
      this.props.campaignApprovalFlowRequest,
    );
    const renderChannelGroupCardTitleLink = () => {
      if (!isHedwigOrTrident) {
        return null;
      }

      if (link) {
        return (
          <a
            href={link}
            target="_blank"
            className="campaign-channel-group-card-title-link"
          >
            Open in {_.capitalize(channelGroup)}
          </a>
        );
      }

      if (!channelGroupLabelCreate) {
        return null;
      }

      const { label, href, onClick } = channelGroupLabelCreate;
      const linkProps = href ? { href, target: '_blank' } : {};
      const onClickHandler = onClick || (() => {});

      return (
        <a
          className="campaign-channel-group-card-title-link"
          style={href ? { cursor: 'pointer' } : {}}
          {...linkProps}
          onClick={onClickHandler}
        >
          {label}
        </a>
      );
    };

    const isDraft = status === 'DRAFT';
    const mamCampaignID = _.get(campaignView, 'campaign.mamCampaignID');
    const nodes = _.get(tridentCampaignView, 'campaign.nodes', {});
    const templateType = _.get(tridentCampaignView, 'campaign.templateType');
    const isJourneyCampaign =
      templateType === TRIDENT_CAMPAIGN_TEMPLATE.multistepJourney;
    const statusUpper = _.toUpper(status);
    const isCampaignDeactivated = INTERNAL_STATUS.deactivated === statusUpper;
    const isCampaignRunning = INTERNAL_STATUS.active === statusUpper;
    const isShowSelectMenu = isShowSelectMenu && !isJourneyCampaign;
    const isPendingApproval = _.get(campaignView, 'campaign.isPendingApproval');
    const hasCreatePermission = hasTridentPermission(
      userPermissions,
      '',
      '',
      'create',
    );
    const hasUpdatePermission = hasTridentPermission(
      userPermissions,
      '',
      '',
      'update',
    );
    const isTaiwanCreationAllowed = isTaiwanCampaignCreationAllowed(
      countryID,
      user.email,
    );

    const showAddCampaignButton =
      isDraft
      && _.isEmpty(mamCampaignID)
      && hasCreatePermission
      && isTaiwanCreationAllowed;
    const showRequestApprovalButton =
      isDraft &&
      !_.isEmpty(mamCampaignID) &&
      !isPendingApproval &&
      hasUpdatePermission;
    const showWithdrawButton =
      isDraft &&
      !_.isEmpty(mamCampaignID) &&
      isPendingApproval &&
      hasUpdatePermission;

    const campaignOptions = [
      {
        displayName: 'Edit',
        value: 'edit',
        icon: EditIcon,
        disabled: isShowSelectMenu,
        callback: () =>
          router.push(UCD_ROUTES_LINK.CAMPAIGN_EDIT(projectID, campaignID)),
      },
      {
        displayName: 'Duplicate',
        value: 'duplicate',
        icon: DuplicateIcon,
        disabled: isShowSelectMenu || !isTaiwanCreationAllowed,
        callback: () =>
          router.push(
            UCD_ROUTES_LINK.CAMPAIGN_DUPLICATE(projectID, campaignID),
          ),
      },
    ];

    if (
      tridentCampaignView.campaignID !== undefined &&
      !isCampaignDeactivated
    ) {
      campaignOptions.push({
        displayName: 'Deactivate',
        value: 'deactivate',
        icon: DeactivateIcon,
        disabled: isCampaignDeactivated,
        callback: () =>
          this.props.deactivateTridentCampaign(
            countryID,
            mamCampaignID,
            user.email,
          ),
      });
    }

    if (
      tridentCampaignView.campaignID !== undefined &&
      isJourneyCampaign &&
      !isCampaignRunning
    ) {
      campaignOptions.splice(1, 0, {
        displayName: 'Edit Journey',
        value: 'editJourney',
        icon: EditIcon,
        disabled: isShowSelectMenu,
        callback: () => {
          router.push(
            UCD_ROUTES_LINK.JOURNEY_CAMPAIGN_BUILDER_EDIT(projectID, campaignID),
          );
        },
      });
    }

    return (
      <div className={'ucd-basic'}>
        <ProgressiveContainer isLoading={isLoadingPage}>
          <div className="campaign-page-header" style={{ marginBottom: 0 }}>
            <Link
              className="campaign-back-button-link"
              onClick={() =>
                this.handleBackButton(previousPageIsListing, projectID)
              }
            >
              <div className="campaign-page-header-back-button">
                <Icon type="grabicon-arrow-back-02" />
              </div>
              <div className="campaign-page-header-back-title">
                {previousPageIsListing ? 'Back' : 'Back to Project Detail Page'}
              </div>
            </Link>
            <div style={{ flex: 1 }} />
            <React.Fragment>
              {statusUpper === INTERNAL_STATUS.draft && (
                <ShowIfAuthorized
                  conditions={[
                    {
                      resource: UCD_RESOURCE_NAMES.campaign,
                      action: UCD_ACTION_TYPES.active,
                    },
                  ]}
                >
                  <Button
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      fontWeight: 'bold',
                      marginRight: 8,
                    }}
                    type={'primary'}
                    loading={
                      isRequestsPending(
                        this.props.updateCampaignStatusRequest,
                      ) &&
                      this.state.statusRequestType === INTERNAL_STATUS.active
                    }
                    onClick={() => {
                      this.setState({
                        statusRequestType: INTERNAL_STATUS.active,
                      });
                      activateCampaign(projectID, campaignID, user.email);
                    }}
                  >
                    Publish
                  </Button>
                </ShowIfAuthorized>
              )}
              {!isShowSelectMenu && (
                <ShowIfAuthorized
                  conditions={[
                    {
                      resource: UCD_RESOURCE_NAMES.campaign,
                      action: UCD_ACTION_TYPES.active,
                    },
                  ]}
                >
                  <Button
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      fontWeight: 'bold',
                    }}
                    type={'danger'}
                    onClick={() => {
                      const it = this;
                      Modal.confirm({
                        title: `Deactivate "${name}"?`,
                        okText: 'Deactivate',
                        okType: 'danger',
                        content:
                          'This will deactivate the campaign. Once deactivated, it can NOT be activated any more!',
                        onOk: function onOk() {
                          it.setState({
                            statusRequestType: INTERNAL_STATUS.deactivated,
                          });
                          deactivateCampaign(projectID, campaignID, user.email);
                        },
                        onCancel: function onCancel() {},
                      });
                    }}
                  >
                    Deactivate
                  </Button>
                </ShowIfAuthorized>
              )}
            </React.Fragment>
          </div>
          <div
            style={
              isShowSelectMenu
                ? {
                  position: 'relative',
                  userSelect: 'none',
                  cursor: 'not-allowed',
                }
                : {}
            }
          >
            <div className="campaign-page-title-row" style={{ paddingTop: 40 }}>
              <div>
                <div className="campaign-page-title-main">{name}</div>
                {!_.isEmpty(editRecords) && (
                  <div style={{ marginTop: 8 }}>
                    <a
                      onClick={this.handleShowVersionHistory}
                      style={{
                        color: '#1890ff',
                        cursor: 'pointer',
                        textDecoration: 'underline',
                        fontSize: 14,
                      }}
                    >
                      View version history
                    </a>
                  </div>
                )}
              </div>
              {!isShowSelectMenu && (
                <ShowIfAuthorized
                  conditions={[
                    {
                      resource: UCD_RESOURCE_NAMES.campaign,
                      action: UCD_ACTION_TYPES.create,
                    },
                    {
                      resource: UCD_RESOURCE_NAMES.campaign,
                      action: UCD_ACTION_TYPES.update,
                    },
                  ]}
                >
                  <SingleSelectMenu
                    overlayConfig={{
                      customClassName: 'campaign-detail-actions',
                      xAxisCorrection: 50,
                      yAxisCorrection: -50,
                    }}
                    options={campaignOptions}
                  />
                </ShowIfAuthorized>
              )}
            </div>
            <div className="ucd-nav">
              <Tabs defaultActiveKey={CAMPAIGN_DETAIL_TABS.overview}>
                <Tabs.TabPane
                  key={CAMPAIGN_DETAIL_TABS.overview}
                  tab={this.getTabLabel(CAMPAIGN_DETAIL_TABS.overview)}
                >
                  <Form layout="vertical">
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                      }}
                    >
                      <div style={{ width: '65%', paddingRight: 54 }}>
                        {!_.isEmpty(
                          _.get(campaignView, 'campaign.mamCampaignID'),
                        ) && (
                            <div style={{ paddingBottom: 26 }}>
                              <div className="campaign-channel-group campaign-channel-group-view">
                              Channel Group
                              </div>
                              <Card
                                headStyle={{ padding: 0 }}
                                bodyStyle={{ padding: 0 }}
                                title={
                                  <div className="campaign-channel-group-card-title">
                                    <div className="campaign-channel-group-card-title-name">
                                      <AddCampaignTypeForm
                                        channelGroup={channelGroup}
                                        hideOptions={[
                                          'channelType',
                                          'channelGroupTitle',
                                        ]}
                                      />
                                    </div>
                                    {renderChannelGroupCardTitleLink()}
                                  </div>
                                }
                              >
                                <div className="campaign-channel-group-card-content">
                                  {link ? (
                                    <React.Fragment>
                                      <div
                                        className="campaign-channel-group-link-visible"
                                        style={{ flex: 1 }}
                                      >
                                        {link}
                                      </div>
                                      <div
                                        onClick={() => {
                                          copyToClipboard(link);
                                          Toastr.success('Copied!');
                                        }}
                                        style={{
                                          cursor: 'pointer',
                                          position: 'relative',
                                          top: '2px',
                                        }}
                                      >
                                        <img
                                          src={DuplicateIcon}
                                          height={'14px'}
                                          width={'14px'}
                                          alt={''}
                                        />
                                      </div>
                                    </React.Fragment>
                                  ) : (
                                    'No Channel ID / URL added'
                                  )}
                                </div>
                              </Card>
                            </div>
                          )}
                        <div className="campaign-page-detail-title">
                          Campaign Details
                        </div>
                        <Flex
                          wrap="wrap"
                          gap={16}
                          vertical={false}
                          justify="space-between"
                        >
                          <DataBox
                            label={'Status'}
                            width="49%"
                            content={
                              <UCDStatusLabel
                                status={status}
                                start={start}
                                end={end}
                                labelSize={'medium'}
                              />
                            }
                          />

                          <DataBox
                            label="Project"
                            width="49%"
                            content={getLinker(
                              projectView.project.name,
                              UCD_ROUTES_LINK.PROJECT_VIEW(projectID),
                            )}
                          />

                          <DataBox
                            label="Channel type"
                            width="49%"
                            content={
                              <span>
                                {channels && channels.length
                                  ? _.map(channels, (ch) => (
                                    <Tag
                                      className="campaign-page-channel-type-tag"
                                      size="xsmall"
                                    >
                                      {_.startCase(_.toLower(ch))}
                                    </Tag>
                                  ))
                                  : _.toUpper(audience)}
                              </span>
                            }
                          />

                          <DataBox
                            label="Goal"
                            width="49%"
                            content={
                              <UCDObjectiveLabel
                                objective={objective}
                                iconSize={32}
                                fontSize={14}
                                fontWeight={500}
                              />
                            }
                          />
                          <DataBox
                            label="Start date"
                            content={campaignStartTime}
                            width="49%"
                          />
                          <DataBox
                            label="End date"
                            content={campaignEndTime}
                            width="49%"
                          />
                          <DataBox
                            label="Budget"
                            content={
                              <span>
                                {_.get(
                                  BUDGET_SOURCE_DISPLAY_NAMES,
                                  budgetSource,
                                )}
                              </span>
                            }
                            width="49%"
                          />
                          <DataBox
                            label="Vertical"
                            content={
                              <span>
                                {_.map(verticals, (el) =>
                                  _.get(VERTICALS_DISPLAY_NAMES, el),
                                ).toString()}
                              </span>
                            }
                            width="49%"
                          />
                          <DataBox
                            label="Campaign code (generated)"
                            content={code}
                            enableContentCopy
                            width="49%"
                          />
                          <DataBox label="Creator" content={createdBy} width="49%" />
                        </Flex>
                        {isJourneyCampaign && (
                          <Row>
                            <Col span={24}>
                              <Form.Item
                                className="sub-form-campaign-item sub-form-campaign-item-view"
                                label={
                                  <span
                                    style={{
                                      fontWeight: 500,
                                      fontSize: 18,
                                      color: '#1a1a1a',
                                    }}
                                  >
                                    Journey
                                  </span>
                                }
                                style={{
                                  marginBottom: 24,
                                  width: '100%',
                                }}
                              >
                                <Row style={{ minHeight: 400 }}>
                                  <Col span={24}>
                                    <JourneyBuilder isView data={nodes} />
                                  </Col>
                                </Row>
                              </Form.Item>
                            </Col>
                          </Row>
                        )}

                        {!_.isEmpty(otherDetails) && (
                          <React.Fragment>
                            <Divider />
                            <div className={'campaign-page-other-detail'}>
                              Other Details
                            </div>
                            {(!_.isEmpty(conditionDetails) ||
                              !_.isEmpty(actionDetails)) && (
                                <Row className={'other-details'} gutter={24}>
                                  <Col className={'item-text'} span={12}>
                                    <Form.Item
                                      label="Condition"
                                      style={{ marginBottom: 16 }}
                                    >
                                      {_.map(conditionDetails, (item) => (
                                        <div>{item.label} </div>
                                      ))}
                                    </Form.Item>
                                  </Col>
                                  <Col className={'item-text'} span={12}>
                                    <Form.Item
                                      label="Action to Triger"
                                      style={{ marginBottom: 16 }}
                                    >
                                      {_.map(actionDetails, (item) => (
                                        <div>{item.label}</div>
                                      ))}
                                    </Form.Item>
                                  </Col>
                                </Row>
                              )}
                            {(!_.isEmpty(segmentDetails) ||
                              !_.isEmpty(hedwigDetails)) && (
                                <Row className={'other-details'} gutter={24}>
                                  <Col className={'item-text'} span={12}>
                                    <Form.Item
                                      label="Segment"
                                      style={{ marginBottom: 16 }}
                                    >
                                      {_.map(segmentDetails, (item) =>
                                        getLinker(
                                          item.label,
                                          getSegmentUrl(userType, item.ID),
                                        ),
                                      )}
                                    </Form.Item>
                                  </Col>
                                  <Col className={'item-text'} span={12}>
                                    <Form.Item
                                      label="Hedwig"
                                      style={{ marginBottom: 16 }}
                                    >
                                      {_.map(hedwigDetails, (item) =>
                                        getLinker(
                                          item.ID,
                                          getHedwigTemplateUrl(
                                            actionTypeToTemplateType[item.type],
                                            item.ID,
                                          ),
                                        ),
                                      )}
                                    </Form.Item>
                                  </Col>
                                </Row>
                              )}
                          </React.Fragment>
                        )}
                      </div>
                      <div
                        style={{
                          width: 1,
                          backgroundColor: '#E8E8E8',
                          marginRight: 43,
                        }}
                      />
                      <ShowIfAuthorized
                        conditions={[
                          {
                            resource: UCD_RESOURCE_NAMES.campaign,
                            action: UCD_ACTION_TYPES.create,
                          },
                        ]}
                      >
                        {channelGroup === CHANNEL_GROUPS.trident &&
                          (showAddCampaignButton ||
                            showRequestApprovalButton ||
                            showWithdrawButton) && (
                            <div className="campaign-status-tracker-panel">
                              {showAddCampaignButton && (
                                <Card className={'campaign-status-tracker'}>
                                  <img
                                    src={addCampaignIcon}
                                    height={'48px'}
                                    alt={''}
                                  />
                                  <section>
                                    <div className={'header'}>
                                      Start your own campaign
                                    </div>
                                    <div className={'content'}>
                                      Boost conversions by personalizing your
                                      projects.
                                    </div>
                                    <Button
                                      className={'btn-add-campaign'}
                                      onClick={
                                        this.handleClickAddTridentCampaign
                                      }
                                    >
                                      Add Trident Campaign
                                    </Button>
                                  </section>
                                </Card>
                              )}
                              {showRequestApprovalButton && (
                                <div className={'campaign-set-up'}>
                                  <h3>Campaign Set-up</h3>
                                  <Card className={'campaign-status-tracker'}>
                                    <img
                                      src={campaignReviewIcon}
                                      height={'48px'}
                                      alt={''}
                                    />
                                    <section>
                                      <div className={'header'}>
                                        Need Approval for Campaign Review
                                      </div>
                                      <div className={'content'}>
                                        To continue creating the campaign, you
                                        need a review from the relevant
                                        approver.
                                      </div>
                                      <a
                                        className={'btn-primary'}
                                        onClick={this.handleRequestApproval}
                                        href={''}
                                      >
                                        Continue Set Approver
                                      </a>
                                    </section>
                                  </Card>
                                </div>
                              )}
                              {showWithdrawButton && (
                                <Card className={'campaign-status-tracker'}>
                                  <img
                                    src={pendingApprovalIcon}
                                    height={'48px'}
                                    alt={''}
                                  />
                                  <section>
                                    <div className={'header'}>
                                      Your campaign is pending approval
                                    </div>
                                    <div className={'content'}>
                                      If you need to edit the campaign, please
                                      withdraw your request for approval.
                                    </div>
                                    <Button
                                      style={{ border: 0, padding: 0 }}
                                      className={'btn-primary text-button'}
                                      loading={isWithdrawRequestPending}
                                      onClick={this.handleWithdraw}
                                    >
                                      Withdraw campaign
                                    </Button>
                                  </section>
                                </Card>
                              )}
                            </div>
                          )}
                      </ShowIfAuthorized>
                    </div>
                  </Form>
                </Tabs.TabPane>
                <Tabs.TabPane
                  className="performance-panel"
                  key={CAMPAIGN_DETAIL_TABS.performance}
                  disabled={isMetricsTabDisabled}
                  tab={
                    <div>
                      {this.getTabLabel(CAMPAIGN_DETAIL_TABS.performance)}{' '}
                      {isMetricsAvailable && (
                        <span className="project-page-metrics-indicator" />
                      )}
                    </div>
                  }
                >
                  <PerformancePage
                    projectView={projectView}
                    campaignView={campaignView}
                  />
                </Tabs.TabPane>
              </Tabs>
            </div>
          </div>
        </ProgressiveContainer>
        {this.state.showApprovalRequestModal && (
          <CampaignApprovalRequestForm
            closeModal={this.closeRequestApprovalModal}
            campaignView={campaignView}
            conditionDetails={conditionDetails}
            actionDetails={actionDetails}
            segmentDetails={segmentDetails}
            hedwigDetails={hedwigDetails}
            getLinker={getLinker}
            editingUrl={`/ucd/project/${projectID}/campaign/${campaignID}/view?/view?previousPageIsListing=true`}
          />
        )}
        {this.state.showVersionHistoryModal && (
          <Modal
            title="Version History"
            visible
            onCancel={this.closeVersionHistoryModal}
            footer={[
              <Button key="close" onClick={this.closeVersionHistoryModal}>
                Close
              </Button>,
            ]}
            width={800}
          >
            <VersionHistoryList
              records={editRecords}
              campaignID={campaignID}
              auditLogHost={_.get(featureFlagConfig, 'auditLogUrl', '')}
              auditLogIndex={_.get(featureFlagConfig, 'auditLogIndex', '')}
              changeTypeToResourceType={(): string => {
                return 'Campaign';
              }}
            />
          </Modal>
        )}
      </div>
    );
  }
}

export function mapStateToProps(state: any, ownProps: any) {
  const userPermissions = state.app.user.userPermissions;
  const countries = state.countries.entities;
  const queryParams = new URLSearchParams(ownProps.location.search);
  return {
    projectID: ownProps.params.entityID,
    campaignID: ownProps.params.campaignID,
    previousPageIsListing: queryParams.get(
      QUERY_PARAM_KEYS.previousPageIsListing,
    ),
    featureFlagConfig: _.get(state, 'newTridents.featureFlagConfig', {}),
    countries,
    user: state.app.user,
    userPermissions,
    campaignView: state.ucd.campaignView,
    tridentCampaignView: state.ucd.tridentCampaignView,
    projectView: state.ucd.projectView,
    approvalRequest: _.get(state, 'newTridents.approvalRequest', {}),
    updateCampaignStatusRequest: _.get(
      state.requests,
      getRequestStateKey(UPDATE_UCD_CAMPAIGN_STATUS),
      {},
    ),
    deactivateTridentCampaignRequest: _.get(
      state.requests,
      getRequestStateKey(DEACTIVATE_TRIDENT_CAMPAIGN),
      {},
    ),
    campaignApprovalFlowRequest: _.get(
      state.requests,
      getRequestStateKey(CAMPAIGN_APPROVAL_FLOW),
      {},
    ),
    getCampaignRequest: _.get(
      state.requests,
      getRequestStateKey(GET_UCD_CAMPAIGN),
      {},
    ),
    getProjectRequest: _.get(
      state.requests,
      getRequestStateKey(GET_UCD_PROJECT),
      {},
    ),
    getTridentCampaignRequest: _.get(
      state.requests,
      getRequestStateKey(GET_TRIDENT_CAMPAIGN),
      {},
    ),
  };
}

export const mapDispatchToProps = (dispatch: any) => ({
  getCampaign: (projectID: string, campaignID: string) => {
    dispatch(getUCDCampaign(projectID, campaignID));
  },
  getProject: (projectID: string) => {
    dispatch(getUCDProject(projectID));
  },
  withdrawTridentCampaign: (
    countryID: number,
    campaignID: string,
    data: any,
  ) => {
    dispatch(
      doCampaignApprovalFlowAction(
        countryID,
        campaignID,
        campaignApprovalFlowActions.withdraw,
        data,
      ),
    );
  },
  activateCampaign: (projectID: string, campaignID: string, user: string) => {
    dispatch(
      updateUCDCampaignStatus(
        INTERNAL_STATUS.active,
        user,
        projectID,
        campaignID,
      ),
    );
  },
  deactivateCampaign: (projectID: string, campaignID: string, user: string) => {
    dispatch(
      updateUCDCampaignStatus(
        INTERNAL_STATUS.deactivated,
        user,
        projectID,
        campaignID,
      ),
    );
  },
  deactivateTridentCampaign: (countryID: number, campaignID: string, user: string) => {
    dispatch(deactivateTridentCampaign(countryID, campaignID, user));
  },
  getTridentCampaign: (projectID: string, campaignID: string) => {
    dispatch(getTridentCampaign(projectID, campaignID));
  },
  getFeatureFlagConfig: () => {
    dispatch(getFeatureFlagConfig());
  },
});


const CampaignDetailPageAuhtorized = connect(
  mapStateToProps,
  mapDispatchToProps,
)(CampaignDetailPage);

const CampaignDetailPageComponent = (props: Props) => (
  <ShowIfAuthorized
    conditions={[
      {
        resource: UCD_RESOURCE_NAMES.campaign,
        action: UCD_ACTION_TYPES.read,
      },
    ]}
    unauthorizedContent={
      <Alert
        message="You don't have access to Holos campaign"
        showIcon
        type="error"
      />
    }
  >
    <CampaignDetailPageAuhtorized {...props} />
  </ShowIfAuthorized>
);

export default CampaignDetailPageComponent;
